export default __webpack_public_path__ + "static/media/nasa_prica.d3d677e1.png";